<template>
    <div class="section-heading">
        <div class="row align-items-center">
            <div class="col-md-4">
                <img :src="image" class="img-fluid" alt="">
            </div>
            <div class="col-md-5">
                <div class="heading-wrap">
                    <div class="sub-heading" :style="`color: ${color}`">
                        {{ subHeading }}
                    </div>
                    <h2 class="heading">
                        {{  heading }}
                    </h2>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SectionHeading",
    props: {
        color: {
            type: String,
        },
        image: {
            type: String,
        },
        subHeading: {
            type: String,
        },
        heading: {
            type: String,
        },
    }
}
</script>

<style lang="scss" scoped>
.heading-wrap{
    font-size: 3rem;
    font-weight: $font-weight-bold;
}
.sub-heading{
    font-size: 0.6em;
}
.heading{
    font-size: 1em;
}
</style>
